import produce from 'immer';
import margeById from '../../helpers/margeById';

export const actions = {
  /**
   * Action that fire/trigger redux-saga watchers
   */
  CHECK_CUSTOMER_LIMITS: 'CHECK_CUSTOMER_LIMITS',
  CHECK_CUSTOMER_LIMITS_SUCCCESS: 'CHECK_CUSTOMER_LIMITS_SUCCCESS',

};

const initialState = {
  limit: false
};

export default produce((draft, action) => {
  const { type, payload } = action;

  if (!draft) {
    return initialState;
  }

  switch (type) {
   case actions.CHECK_CUSTOMER_LIMITS_SUCCCESS: {
      draft.limit = payload
    }
    

    default:
      break;
  
}});
